import { graphql, useFragment } from 'react-relay';

import {
  AlimTalkTemplateStatusLabel_alimTalkTemplate$key,
  TemplateStatusEnum,
} from '../../../relay/__generated__/AlimTalkTemplateStatusLabel_alimTalkTemplate.graphql';
import EnumPair from '../../core/EnumPair';
import Label, { LabelProps } from '../../core/Label';

const AlimTalkTemplateStatusLabel_alimTalkTemplate = graphql`
  fragment AlimTalkTemplateStatusLabel_alimTalkTemplate on AlimTalkTemplate {
    templateStatus
    isBlock
    isDormant
  }
`;

type Props = {
  alimTalkTemplate: AlimTalkTemplateStatusLabel_alimTalkTemplate$key;
} & Omit<LabelProps, 'variant'>;

/**
 * 카카오는 템플릿 상태를 templateStatus / isBlock / isDormant 세 필드로 쪼개서 준다.
 * (차단은 templateStatus 가 'A'(정상) 인 채로 isBlock 만 true 로 온다)
 * 비즈뿌리오 콘솔과 동일하게 한 칼럼으로 합쳐 보여준다.
 */
const AlimTalkTemplateStatusLabel = ({ alimTalkTemplate, ...props }: Props) => {
  const { templateStatus, isBlock, isDormant } = useFragment(
    AlimTalkTemplateStatusLabel_alimTalkTemplate,
    alimTalkTemplate,
  );

  if (isBlock)
    return (
      <Label variant={'danger'} {...props}>
        {'차단'}
      </Label>
    );

  if (isDormant)
    return (
      <Label variant={'secondary'} {...props}>
        {'휴면'}
      </Label>
    );

  const labelPropsByStatus: Record<TemplateStatusEnum, LabelProps> = {
    'A': { variant: 'success' },
    'S': { variant: 'danger' },
    'R': { variant: 'attention' },
    '%future added value': {},
  };

  return (
    <Label {...labelPropsByStatus[templateStatus]} {...props}>
      <EnumPair typename={'TemplateStatusEnum'}>{templateStatus}</EnumPair>
    </Label>
  );
};

export default AlimTalkTemplateStatusLabel;
